import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useIconSwapService } from './IconSwapService.jsx';
import { round, formatNumber } from '../utils/Conversions.js';

import DownArrow from '../images/DownArrow.svg';
import AreaGraph from './AreaGraph';

const swapTypes = {
  AC3: 'cx9ab3078e72c8d9017194d17b34b1a47b661945ca',
  SPORTS: 'cx08eb683a53d6f244d538a45f0cc584825e2cb985',
  TAP: 'cxc0b5b52c9f8b4251a47e91dda3bd61e5512cd782',
  WOK: 'cx921205acb7c51e16d5b7cbc37539a4357d929d20',
  ICX: 'cx0000000000000000000000000000000000000000',
};

export const TransactionHistoryGraphPanel = ({
  swapType,
}: TransactionHistoryGraphPanelTypes) => {
  const { marketInfo, tokenInfo } = useIconSwapService();
  const [latestPrice, setLatestPrice] = useState<number>();
  const [change, setChange] = useState<string | number>();
  const [volume, setVolume] = useState<string>();
  const [token, setToken] = useState();

  useEffect(() => {
    addData();
    // @ts-ignore
    setToken(swapTypes[swapType]);
    marketInfo &&
      marketInfo.map((token: any, index: number) => {
        if (swapType === 'TAP' && token.name === 'TapToken') {
          return setLatestPrice(round(token.last_price, 5));
        }
        if (swapType === 'WOK' && token.name === 'weBloc') {
          return setLatestPrice(round(token.last_price, 5));
        }
        if (swapType === 'SPORTS' && token.name === 'SportsToken') {
          return setLatestPrice(round(token.last_price, 5));
        }
        if (swapType === 'AC3' && token.name === 'AC3') {
          return setLatestPrice(round(token.last_price, 5));
        }
      });
  }, [marketInfo, tokenInfo, swapType]);

  const addData = () => {
    // @ts-ignore
    const token = swapTypes[swapType];
    return (
      tokenInfo &&
      tokenInfo.map((item: any) => {
        if (token === item.contract) {
          if (item.change === 0) {
            setChange('-');
          }
          if (item.change > 0) {
            setChange(item.change);
          }

          if (item.volume > 0) {
            setVolume(item.volume);
          }
          if (item.change < 1) {
            setVolume('-');
          }
        }
      })
    );
  };

  const showChangeData = () => {
    if (typeof change === 'string') {
      return <ChangeText>{change}</ChangeText>;
    }
    if (change && change < 0) {
      return <NegativeChangeText>-{change}%</NegativeChangeText>;
    }
    if (change && change > 0) {
      return <PositiveChangeText>+{change}%</PositiveChangeText>;
    }
  };

  return (
    <TransactionHistoryGraphPanelWrapper>
      <HeadingWrapper>
        <HeadingText>Transaction History (ICX/{swapType})</HeadingText>
        {/* <TimeSelect>
          <TimeSelectOption value='Daily'>Daily</TimeSelectOption>
          <TimeSelectOption value='Monthly'>Monthly</TimeSelectOption>
          <TimeSelectOption value='Yearly'>Yearly</TimeSelectOption>
        </TimeSelect> */}
      </HeadingWrapper>
      <VolumeChangeContainer>
        <PriceColumn>
          <ColumnTitle>Latest Price</ColumnTitle>
          <PriceVolumeText>{latestPrice} ICX</PriceVolumeText>
        </PriceColumn>
        <ChangeColumn>
          <ColumnTitle>24h Change</ColumnTitle>
          {showChangeData()}
        </ChangeColumn>
        <VolumeColumn>
          <ColumnTitle>24h Volume</ColumnTitle>
          <PriceVolumeText>
            {!volume ? '-' : formatNumber(volume)} ICX
          </PriceVolumeText>
        </VolumeColumn>
      </VolumeChangeContainer>
      <AreaGraphWrapper>
        <AreaGraph token={token} />
      </AreaGraphWrapper>
    </TransactionHistoryGraphPanelWrapper>
  );
};

export default TransactionHistoryGraphPanel;

const TransactionHistoryGraphPanelWrapper = styled.div`
  height: 580px;
  width: 1050px;
  background-color: #fff;
  padding: 30px;
  box-shadow: 2px 2px 6px 2px #e9ebec;
  border-radius: 5px;
  border-color: #e9ebec;
  border-style: solid;
  border-width: 0.5px;
  @media (max-width: 414px) {
    width: 335px;
    overflow: scroll;
    padding-top: 15px;
    padding-bottom: 40px;
    border-bottom: 1px solid #e9ebec;
  }
`;

const HeadingWrapper = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const HeadingText = styled.h3`
  font-size: 26px;
  font-weight: 600;
  @media (max-width: 414px) {
    color: #070707;
    font-family: 'Avenir Next';
    font-size: 19px;
    font-weight: 600;
  }
`;

const TimeSelect = styled.select`
  height: 40px;
  width: 165px;
  font-size: 15px;
  appearance: none;
  padding-left: 20px;
  background-image: src(${DownArrow});
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
`;

const TimeSelectOption = styled.option``;

const VolumeChangeContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 350px;
  justify-content: space-between;
  @media (max-width: 414px) {
    width: 275px;
    margin-bottom: 5px;
  }
`;

const PriceColumn = styled.div`
  width: 116px;
  @media (max-width: 414px) {
    display: flex;
    flex-direction: column;
    width: 68.5px;
  }
`;

const ChangeColumn = styled.div`
  width: 130px;
  @media (max-width: 414px) {
    display: flex;
    flex-direction: column;
    width: 68.5px;
  }
`;

const VolumeColumn = styled.div`
  width: 116px;
  @media (max-width: 414px) {
    display: flex;
    flex-direction: column;
    width: 68.5px;
  }
`;

const PriceVolumeText = styled.p`
  margin: 0px;
  font-size: 15px;
  @media (max-width: 414px) {
    color: rgba(16, 15, 16, 0.5);
    font-family: 'Avenir Next';
    font-size: 13px;
    font-weight: 500;
  }
`;

const ColumnTitle = styled.h4`
  font-size: 15px;
  @media (max-width: 414px) {
    font-family: 'Avenir Next';
    font-size: 15px;
    font-weight: 600;
  }
`;

const ChangeText = styled.p`
  margin: 0px;
  font-size: 15px;

  @media (max-width: 414px) {
    color: rgba(16, 15, 16, 0.5);
    font-family: 'Avenir Next';
    font-size: 13px;
    font-weight: 500;
  }
`;

const PositiveChangeText = styled.p`
  margin: 0px;
  font-size: 15px;
  color: #4fb83b;
  @media (max-width: 414px) {
    color: rgba(16, 15, 16, 0.5);
    font-family: 'Avenir Next';
    font-size: 13px;
    font-weight: 500;
  }
`;

const NegativeChangeText = styled.p`
  margin: 0px;
  font-size: 15px;
  color: #de3617;
  @media (max-width: 414px) {
    color: rgba(16, 15, 16, 0.5);
    font-family: 'Avenir Next';
    font-size: 13px;
    font-weight: 500;
  }
`;

const AreaGraphWrapper = styled.div`
  margin-top: 35px;
  @media (max-width: 414px) {
    transform: rotate(-90deg);
    margin-top: 0;
  }
`;

type TransactionHistoryGraphPanelTypes = {
  swapType: string;
};
